// extracted by mini-css-extract-plugin
export default {"sizeButtons":"KevLBR","sizeButton":"B8ND4x","sizeLabels":"IXldmv","sizeLabel":"xg_qYT"};